<template>
  <div>
    <Modal />
  </div>
</template>

<script>
import Modal from "../../../components/tools/Modal.vue";
export default {
  components: {
    Modal,
  },
};
</script>
